import {useListView} from './core/ListViewProvider'
import {useQueryResponse, useQueryResponseData} from './core/QueryResponseProvider'
import {QUERIES} from '../../../../../_metronic/helpers'
import {fields} from './core/_models'
import {createContactUs, deleteContactUs, updateContactUs} from './core/_requests'
import {KModal} from '../../../../../_component/modal/Modal'

export const ViewEditModal = () => {
  const {setItemIdForUpdate, itemIdForUpdate, setItemIdToView, itemIdToView} = useListView()
  const {refetch} = useQueryResponse()
  const contacts = useQueryResponseData()

  return (
    <KModal
      model={QUERIES.CONTACT_US_LIST}
      title='Contact Us'
      setItemIdForUpdate={setItemIdForUpdate}
      itemIdForUpdate={itemIdForUpdate}
      setItemIdToView={setItemIdToView}
      itemIdToView={itemIdToView}
      fields={fields}
      data={contacts}
      update={updateContactUs}
      create={createContactUs}
      delete={deleteContactUs}
      refetch={refetch}
    />
  )
}
